import {
  SpeciesBinomen,
  SpeciesFootNumber,
  SpeciesVolume,
  SpeciesUnitCost,
  SpeciesObservations,
  SpeciesTarget
} from '@/Domain/Batch/Species'

export class Species {
  private _internalId: number
  private _binomen: SpeciesBinomen
  private _footNumber: SpeciesFootNumber | null
  private _volume: SpeciesVolume
  private _morphologyCode: number
  private _unitCost: SpeciesUnitCost | null
  private _sawOne: SpeciesTarget | null
  private _sawTwo: SpeciesTarget | null
  private _grinded: SpeciesTarget | null
  private _observations: SpeciesObservations | null

  constructor (
    internalId: number,
    binomen: SpeciesBinomen,
    footNumber: SpeciesFootNumber | null,
    volume: SpeciesVolume,
    morphologyCode: number,
    unitCost: SpeciesUnitCost | null,
    sawOne: SpeciesTarget | null,
    sawTwo: SpeciesTarget | null,
    grinded: SpeciesTarget | null,
    observations: SpeciesObservations | null
  ) {
    this._internalId = internalId
    this._binomen = binomen
    this._footNumber = footNumber
    this._volume = volume
    this._morphologyCode = morphologyCode
    this._unitCost = unitCost
    this._sawOne = sawOne
    this._sawTwo = sawTwo
    this._grinded = grinded
    this._observations = observations
  }

  binomen (): string {
    return this._binomen.binomen()
  }

  footNumber (): string {
    return this._footNumber === null ? '' : this._footNumber.toString()
  }

  volume (): string {
    return this._volume.toString()
  }

  cost (): string {
    return this._unitCost === null ? '' : this._unitCost.toString()
  }

  observations (): string {
    return this._observations === null ? '' : this._observations.name()
  }

  sawOneCost (): string {
    return this._sawOne === null ? '' : this._sawOne.cost()
  }

  sawOneVolume (): string {
    return this._sawOne === null ? '' : this._sawOne.volume()
  }

  sawTwoCost (): string {
    return this._sawTwo === null ? '' : this._sawTwo.cost()
  }

  sawTwoVolume (): string {
    return this._sawTwo === null ? '' : this._sawTwo.volume()
  }

  grindedCost (): string {
    return this._grinded === null ? '' : this._grinded.cost()
  }

  grindedVolume (): string {
    return this._grinded === null ? '' : this._grinded.volume()
  }

  internalId (): number {
    return this._internalId
  }

  morphologyCode (): number {
    return this._morphologyCode
  }
}
